exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".controlsContainer{overflow:hidden;position:absolute;left:50%;bottom:0;padding-bottom:20px;transform:translate(-50%, 0);border-radius:8px}.controls{transition:all .3s ease-in-out;position:relative;bottom:0;left:0;margin-left:0;opacity:.8}.controls .fa{color:hsla(0,0%,100%,.6);font-size:40px;padding:24px 34px}.controls .playControls{display:inline-block;margin:0 10px}.controls .controlButton{transition:all ease .2s;background:#052a4f;display:inline-block;cursor:pointer}.controls .controlButton:hover{background:#1e3f60}.controls .controlButton:hover .fa{color:hsla(0,0%,100%,.8)}.controls .round{border-radius:8px}.controls .round-left{border-radius:8px 0 0 8px}.controls .round-right{border-radius:0 8px 8px 0}.slideDown{bottom:-110px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded!./client/components/Controls/Controls.scss
 ** module id = 746
 ** module chunks = 0
 **/